//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { transTimeFilter } from "../../../src/filters"
import { Popover } from "vant"
import "vant/lib/popover/style/index"

const handleDocumentClick = (vm, e) => {
  if (!vm.$el || vm.$el.contains(e.target)) {
    return
  }
  vm.rateShow = false
}

const load = (vm, type) => {
  if (type === "reload") {
    // 防止进度条闪跳 暂时移除监听
    vm.audioRef.ontimeupdate = () => {}
  }
  // 重新加载 audio
  vm.audioRef.load()
  // 监听 audio 事件
  vm.audioRef.onloadeddata = () => {
    vm.duration = vm.totalDuration || vm.audioRef.duration
    // vm.playedTime = vm.audioRef.currentTime
    if (vm.startTime) {
      vm.setCurrentTime(vm.startTime)
    }
    vm.$emit("loadeddata", vm)
    if (vm.autoPlay) {
      vm.onPlay()
    }

    // 监听播放时间变化
    vm.audioRef.ontimeupdate = () => {
      vm.playedTime = vm.audioRef.currentTime
      vm.progress = vm.duration > 0 ? ((vm.playedTime * 100) / (vm.duration * 100)).toFixed(5) * 100 : 0
      vm.$emit("timeupdate", vm)
    }
  }
  // 监听播放事件
  vm.audioRef.onplay = () => {
    vm.playing = true
    vm.audioRef.currentRate = vm.currentRate.value
    vm.$emit("play", vm)
  }
  // 监听暂停
  vm.audioRef.onpause = () => {
    vm.playing = false
    vm.onPause()
    vm.$emit("pause", vm)
  }
  // 监听结束
  vm.audioRef.onended = () => {
    vm.onEnded()
    vm.$emit("ended", vm)
  }
  // 监听
  vm.audioRef.oncanplaythrough = () => {
    vm.$emit("canplaythrough", vm)
  }
}

const mediaTypeMap = {
  wav: "audio/wav",
  mp3: "audio/mpeg"
}

export default {
  name: "VocAudioPlayerNext",
  components: { Popover },
  filters: { transTimeFilter },
  props: {
    // 录音名称
    name: {
      type: String,
      default: ""
    },
    // 录音链接
    link: {
      type: String,
      default: "",
      required: true
    },
    // 语音类型
    mediaType: {
      type: String,
      default: "audio/wav"
    },
    // 总时长
    totalDuration: {
      type: Number,
      default: 0
    },
    // 自动播放
    autoPlay: {
      type: Boolean,
      default: true
    },
    startTime: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 标志位
      // 用来判断是否处于播放状态
      playing: false,
      // 语音总时长
      duration: 0,
      // 当前已播放时间
      playedTime: 0,
      // 控制进度条
      progress: 0,
      rateShow: false,
      actions: [
        {
          text: "2.0x",
          value: 2.0
        },
        {
          text: "1.5x",
          value: 1.5
        },
        {
          text: "1.25x",
          value: 1.25
        },
        {
          text: "1.0x",
          value: 1.0
        },
        {
          text: "0.75x",
          value: 0.75
        },
        {
          text: "0.5x",
          value: 0.5
        }
      ],
      currentRate: {
        text: "1.0x",
        value: 1.0
      },
      mediaTypeMap
    }
  },
  computed: {
    // audio dom
    audioRef() {
      return this.$refs["audioRef"]
    },
    actionsList() {
      return this.actions.map(item => {
        if (item.value === this.currentRate.value) {
          item.className = "active"
        } else {
          item.className = ""
        }
        return item
      })
    }
  },
  watch: {
    link() {
      load(this, "reload")
    }
  },
  mounted() {
    document.addEventListener("click", e => handleDocumentClick(this, e))
    if (this.link) {
      load(this)
    }
  },
  methods: {
    isDragHorizontal(d2, d1) {
      return Math.abs(d2.clientX - d1.clientX) > Math.abs(d2.clientY - d1.clientY)
    },
    setCurrentTime(time = 0) {
      this.audioRef && (this.audioRef.currentTime = time)
    },
    /**
     * progress {Number} 进度比例，0~1的小数
     */
    seek(progress) {
      if (this.loading) {
        return
      }
      if (progress > 1) progress = 1
      if (progress < 0) progress = 0
      this.progress = progress * 100
      this.setCurrentTime(progress * this.duration)
    },
    getStageWidth(dom) {
      return this.__stageWidth || (this.__stageWidth = dom.getBoundingClientRect().width)
    },
    onDragSeekStart(e) {
      this.__lastMove = e.touches[0]
    },
    onDragSeek(e) {
      let move = e.touches[0]
      if (this.__lastMove && this.isDragHorizontal(move, this.__lastMove) && e.cancelable) {
        e.preventDefault()
        e.stopPropagation()
        this.seek(this.progress / 100 + (move.clientX - this.__lastMove.clientX) / this.getStageWidth(e.currentTarget))
        this.__lastMove = move
      }
    },
    onClickSeek(e) {
      this.seek(e.offsetX / this.getStageWidth(e.currentTarget))
    },
    onClickPlay() {
      this.$emit("clickPlay", this)
      this.onPlay()
    },
    // 执行播放
    onPlay() {
      if (this.link) {
        if (this.duration - this.playedTime < 0.5) {
          this.setCurrentTime(0)
        }
        let palyPromise = this.audioRef && this.audioRef.play()
        if (palyPromise !== undefined) {
          palyPromise
            .then(() => {
              this.playing = true
            })
            .catch(error => {
              this.playing = false
              console.log(error)
            })
        }
      }
    },
    // 暂停播放
    onPause() {
      if (this.playing) {
        this.audioRef && this.audioRef.pause()
      }
    },
    // 播放完成
    onEnded() {
      this.playing = false
    },
    // 快进或快退
    changeTime(type) {
      if (this.loading) {
        return
      }
      if (type === "back") {
        if (this.playedTime >= 15) {
          this.setCurrentTime(this.playedTime - 15)
        } else {
          this.setCurrentTime(0)
        }
      } else {
        if (this.playedTime < this.duration - 15) {
          this.setCurrentTime(this.playedTime + 15)
        } else {
          this.setCurrentTime(this.duration - 1)
        }
      }
    },
    getContainer() {
      return this.$refs["voc-audio"]
    },
    selectRate(item) {
      this.currentRate = item
      this.audioRef && (this.audioRef.playbackRate = item.value)
    }
  }
}
